import { j as n } from "./jsx-runtime-944c88e2.js";
import "react";
const u = ({ width: e = "80%", color: r = "medium", thickness: t = "medium" }) => {
  const s = o(r), i = c(t);
  return /* @__PURE__ */ n.jsx(
    "div",
    {
      className: `${s}`,
      style: { width: e, height: i, marginLeft: "auto", marginRight: "auto" }
    }
  );
};
function o(e) {
  switch (e) {
    case "light":
      return "lighter-grey-color-bg";
    case "medium":
      return "light-grey-color-bg";
    case "dark":
      return "grey-color-bg";
  }
}
function c(e) {
  switch (e) {
    case "thin":
      return "0.063rem";
    case "medium":
      return "0.125rem";
    case "thick":
      return "0.188rem";
  }
}
export {
  u as Line
};
